module.exports = __webpack_public_path__ + "img/one_0.6cc1ffc2.png";